import { common } from '@tencent/ceiba-base-components';
import Vue from 'vue';

let loginManagerInstance = null;

const isApp = () => /com\.tencent\.gamecommunity/.test(window.navigator.userAgent);
let isClientGame = 2;

let appId = '101863397';
let WxAppId = 'wx3a42583c51c6b803';

if (isApp()) {
  appId = '101821651';
  WxAppId = 'wxd35a5b0c66e8b683';
}


const checkAccountType = () => (common.tool.getCookie('acctype') === 'wx' ? 'wx' : 'qq');

function loginByQQ(loginManager) {
  if (common.platform.isMobile) {
    loginManager.mobileLoginByQQConnect({
      appId,
      redirectUri: 'https://xinyue.qq.com/comm-htdocs/login/qc_redirect.html',
      sUrl: location.href,
    });
  } else {
    // pc环境打开,用pc登录方法
    loginManager.loginByQQConnect({
      appId,
      redirectUri: 'https://xinyue.qq.com/comm-htdocs/login/qc_redirect.html',
      sUrl: location.href,
    });
  }
  
  localStorage.curPlatform = 'qq';
}
function loginByWx(loginManager) {
  // pc微信登录需要用网页应用appid,不能用服务号appid,所以微信登录暂时不做处理
  loginManager.mobileLoginByWX({
    appId: WxAppId, 
    scope: 'snsapi_userinfo', // 默认是 snsapi_base 静默授权，如果游戏无静默权限，就需要手动改成 snsapi_userinfo
    userinfoSpan: 'userinfo',
    sUrl: location.href,
    forcePopup: true,
    snapShotTips: true,
    snapShotCustomTips: '我同意“本活动获取您的个人信息，仅用于该活动的查询、抽奖、领取、发货、签到等操作”',
  });
  
  localStorage.curPlatform = 'wx';
}

export default {

  /**
    * 闪现登录特点
    * 游戏：有手游，有端游
    * 只有APP环境打开
    * 登录: QC + WX
    */
  /**
     * 去登录操作
     * @param {登录方式}
  */
  initLogin: async () => new Promise((resolve) => {
    // if (!isApp()) return;
    isClientGame = Vue.prototype.$actInfo.game_type;
    if (isClientGame === 1 && checkAccountType() === 'wx') {
      // 端游
      alert('该活动仅限QQ用户参与，请重新切换账号');
      return;
    }
    console.log('spark initLogin begin');
    console.log(Vue.prototype.$actInfo.game_type);
    window.iUseQQConnect = 1;
    loginManagerInstance = new Vue.prototype.$miloLoginManager({
      commonParams: {
        iUseQQConnect: window.iUseQQConnect,
      },
      mobileParams: {
        oWXParams: {
          gameDomain: 'shanxian.qq.com',
          appId: WxAppId,
          scope: 'snsapi_userinfo',
          sUrl: location.href,
        },
        oQQConnectParams: {
          appId,
          redirectUri: 'https://shanxian.qq.com/comm-htdocs/login/qc_redirect.html',
          sUrl: location.href,
        },
      },
    });
    console.log('tgclub initLogin done instance=', loginManagerInstance);
    resolve();
  }),
  /**
   * 去登录操作
   * @param {登录方式} loginType
   */
  login: async (params = { loginType: 'qq' }) => {
    // if (!isApp()) return;
    console.log('spark login');
    if (params.loginType === 'qq') loginByQQ(loginManagerInstance);
    if (params.loginType === 'wx') loginByWx(loginManagerInstance);
  },
  /**
   * 检查登录信息，返回是否登录+登录信息
   * @returns {
   *  "isLogin":true,
   *  "userInfo":{}
   * }
   */
  checkLogin: async () => await new Promise((resolve) => {
    // if (!isApp()) {
    //   return resolve({
    //     isLogin: false,
    //     userInfo: {},
    //   });
    // }
    console.log('loginManagerInstance--=---', loginManagerInstance);
    loginManagerInstance.checkRealLogin().then((res) => {
      const { isLogin, userInfo, result } = res;
      console.log('checkRealLogin', userInfo);
      // 同步一份loginType到userInfo,兼容旧组件逻辑
      userInfo.loginType = result.loginType;
      // 采用localStorage 保持登录的连续性 保持活动页面上一次保持登录的方式
      //
      let { curPlatform } = localStorage;
      console.log('checkLogin curPlatform from localStorage ', curPlatform);

      if (!curPlatform) {
        curPlatform = Vue.prototype.$platform.isWX ? 'wx' : 'qq';
      }
      if (isApp()) {
        curPlatform = checkAccountType();
        console.info('[checkRealLogin] checkAppAccountType', curPlatform);
      }
      console.log('checkLogin curPlatform ', curPlatform);
      resolve({
        isLogin,
        userInfo,
      });
    }).catch((err) => {
      common.tool.clearAllCookie();
      resolve({
        isLogin: false,
        userInfo: {},
      });
    });
    
  }),
  /**
   * 登出操作
   */
  logout: async () => {
    await loginManagerInstance.logout().then((res) => {
      // ios存在登出链接地址异常问题
      common.tool.clearAllCookie();
      console.log('supercore user logout res:', res);
      sessionStorage.setItem('logouted', 'true');
    });
    localStorage.curPlatform = '';
  },

};
